<template lang="pug">
div(class='h-10')
  div(class='h-full')
    BaseForm(id='salesContactForm' name='salesContactForm')
      BaseFormSelect(id='salesContactState' v-model='selectedState' :options='states' name='salesContactState')
</template>

<script lang="ts" setup>
const { $algolia } = useNuxtApp()

const states = ref<StateSelect[]>([])
const selectedState = ref('')

watch(selectedState, (newVal) => {
  // Clear existing state
  $algolia.searchContexts.salesReps.clearRefinements('territory.state')
  // if we have a state value then set it
  if (newVal) $algolia.searchContexts.salesReps.addRefinements('territory.state', newVal)
  // trigger new search
  $algolia.searchContexts.salesReps.search()
})

onMounted(async () => {
  await getStates()
})

const getStates = async () => {
  try {
    // this is using a private method we use internally that gets the results but doesn't set the state.
    const { refinements } = await $algolia.searchContexts.salesReps._search()

    // Get state facet from search
    const stateFacetValues = refinements['territory.state'] as AlgoliaRefinement[]

    // If we don't have any then return
    if (!stateFacetValues) return

    // Set brands equal to the values - format for Formkit
    states.value = stateFacetValues.map(({ value, display }) => ({
      label: display,
      value,
    }))

    // Add disabled option to beginning for Formkit
    states.value.unshift({ label: 'Select a State', value: '', attrs: { disabled: true } })
  } catch (error) {
    console.error('Unable to get state facets', error)
  }
}

interface AlgoliaRefinement {
  value: string
  display: string
}

interface StateSelect {
  label: string
  value: string
  attrs?: {
    disabled: boolean
  }
}
</script>
